<template>
  <div>
  <h1 class="mt-24 text-center"> </h1>
  <div class="text-center">  
  <!--img v-for="(itm, index) in eventos" :src="itm.src" :key="index" v-img:name="itm.desc"-->
  <img class="imagen" v-for="(itm, index) in eventos" :src="itm.src" :key="index" v-img:v="{ title: itm.desc}">
  </div>
    <button class="fixed right-0 bottom-0 h-12 w-12 md:h-auto md:w-auto m-6 z-30 flex block p-0 bg-wasap-2 text-secondary rounded-full active:shadow-lg mouse shadow transition ease-in delay-1000 duration-700 focus:outline-none">
            <a href="https://wa.me/584128002579" class="flex my-auto mx-auto">
                <p class="hidden flex my-auto  md:block my-auto m-2 text-xs font-semibold">Conversa con nosotros</p> 
                <img class="rounded-full p-1" src="@/assets/media/ws-green.svg" width="45" height="45">
            </a>
        </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';  
export default {
    computed:{
        ...mapGetters(['getEventos']),
        eventos(){
            return this.getEventos
        }
    },
    methods:{
        ...mapActions(['loadEventos'])
    },
    created(){
        this.loadEventos()
    },
    data() {
        return {
            options: {
                /*index: 0,
                //escKey: false,
                // ui option
                timeToIdle: 4000,
                closeOnScroll: true,
                shareEl: false,
                spacing: 0  ,*/
            },
        };
    }
}
</script>

<style scoped>
  .imagen {
    max-width: 350px;
    max-width: 350px;
    display: inline;
    margin: 5px;
  }
</style>
